<template>
  <span v-if="matchedRenderAction && matchedRenderRendered"
        :class="['grid-cell', 'grid-cell-' + matchedRenderAction.themeType]">
    <template v-if="matchedRenderAction.handlerType === 'AJAX'">
      <a class="action-cell" @click="handleAjaxClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'ROUTE'">
      <a class="action-cell" @click.stop="handleRouteClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'LINK'">
      <a class="action-cell" :href="actionPath" :target="matchedRenderAction.linkTargetType || '_blank'">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'COPY'">
      <a class="action-cell" @click.stop="handleCopyClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'UPDATE'">
      <a class="action-cell" @click.stop="handleUpdateClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'POPUP'">
      <a class="action-cell" @click.stop="handlePopupClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'DRAWER'">
      <a class="action-cell" @click.stop="handleDrawerClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'BUBBLE'">
      <DataGridBubble :key="matchedRenderAction.actionPath"
                      :class="matchedRenderAction.dimension ? 'dimension--' + matchedRenderAction.dimension.type : ''"
                      :visible.sync="popover.isShowBubble"
                      :decorator="matchedRenderAction.decorator"
                      v-bind="$extend({
                        placement: 'right'
                      }, matchedRenderAction.extraAttrs)">
        <a slot="reference" class="action-cell" @click.stop="handleBubbleClick">
          <slot :render-action="matchedRenderAction"
                :render-action-text="matchedRenderActionText"
                :render-action-icon="matchedRenderActionIcon">
            <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
            <span>{{matchedRenderActionText}}</span>
          </slot>
        </a>
        <template slot-scope="scope">
          <DataGridPopover :component-path="matchedRenderAction.actionPath"
                           :visible="popover.isShowBubble"
                           :table-column="tableColumn"
                           :row-index="rowIndex"
                           :row-data="rowData"
                           :cell-value="cellValue"
                           :extra-key="matchedRenderAction.extraKey"
                           :extra-id="cellValue"
                           :extra-value="cellValue"
                           :extra-params="matchedRenderAction.extraParams"
                           :popover-extra="scope"
                           v-bind="$attrs"
                           @reloadGridData="reloadGridData"
                           @hidePopover="hideBubble"
                           @hidePopoverAndRefresh="hideBubbleAndRefresh"
                           @hideBubble="hideBubble"
                           @hideBubbleAndRefresh="hideBubbleAndRefresh"></DataGridPopover>
        </template>
      </DataGridBubble>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'CASCADE'">
      <a class="action-cell" @click.stop="handleCascadeClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'IMPORT'">
      <a class="action-cell" @click.stop="handleImportClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'UNPACK'">
      <a class="action-cell" @click.stop="handleUnpackClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'ASYNC'">
      <a class="action-cell" @click.stop="handleAsyncClick">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </a>
    </template>
    <template v-else-if="matchedRenderAction.handlerType === 'CUSTOM'">
      <Tile :key="matchedRenderAction.actionPath"
            :class="matchedRenderAction.dimension ? 'dimension--' + matchedRenderAction.dimension.type : ''"
            :component-path="matchedRenderAction.actionPath"
            :table-column="tableColumn"
            :row-index="rowIndex"
            :row-data="rowData"
            :cell-value="cellValue"
            :action-text="matchedRenderAction.actionName || matchedRenderActionText"
            :extra-key="matchedRenderAction.extraKey"
            :extra-id="cellValue"
            :extra-value="cellValue"
            :extra-params="matchedRenderAction.extraParams"
            :extra-attrs="matchedRenderAction.extraAttrs"
            v-bind="$attrs"
            @reloadGridData="reloadGridData"></Tile>
    </template>
    <template v-else>
      <span class="action-cell">
        <slot :render-action="matchedRenderAction"
              :render-action-text="matchedRenderActionText"
              :render-action-icon="matchedRenderActionIcon">
          <i v-if="matchedRenderActionIcon" :class="matchedRenderActionIcon"></i>
          <span>{{matchedRenderActionText}}</span>
        </slot>
      </span>
    </template>
  </span>
</template>

<script>
import DataGridPopover from './DataGridPopover'
import DataGridBubble from './DataGridBubble'
import Tile from '../Tile'
import { getValueByPath } from 'element-ui/lib/utils/util'
import { Loading } from 'element-ui'
import ColumnExtra from '../../../mixins/grid/columnExtra'
import objectUtils from '../../../util/objectUtils'
import routeConfig from '../../../constants/routeConfig'
import globalEvent from '../../../constants/globalEvent'
import popover from './popover'
export default {
  mixins: [ColumnExtra],
  name: 'CompositeTableActionCell',
  inject: ['$grid'],
  components: {
    DataGridPopover,
    DataGridBubble,
    Tile
  },
  props: {
    tableColumn: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number,
      required: true
    },
    rowData: {
      type: Object,
      required: true
    }
  },
  provide () {
    return {
      $cell: this
    }
  },
  data () {
    return {
      popover: {
        popupInstance: null,
        drawerInstance: null,
        cascadeInstance: null,
        importInstance: null,
        unpackInstance: null,
        asyncInstance: null,
        isShowBubble: false
      }
    }
  },
  computed: {
    matchedRenderAction: function () {
      let renderAction = this.tableColumn['renderAction']
      if (renderAction) {
        let cellMatcher = renderAction['cellMatcher']
        if (cellMatcher) {
          let cellRenderAction
          cellMatcher.some((cellMatcherItem) => {
            let columnMatcher = cellMatcherItem['columnMatcher']
            if (columnMatcher) {
              for (let index = 0; index < columnMatcher.length; index++) {
                let columnMatcherItem = columnMatcher[index]
                let cellValue = getValueByPath(this.rowData, columnMatcherItem.prop)
                // 必须是全匹配
                let cellRegex = new RegExp('^' + columnMatcherItem.regex + '$')
                if (cellRegex.test(objectUtils.toString(cellValue))) {
                  if (index === columnMatcher.length - 1) {
                    cellRenderAction = cellMatcherItem['renderAction']
                  }
                } else {
                  break
                }
              }
            }
          })
          if (cellRenderAction) {
            return cellRenderAction
          }
        }
        return renderAction
      } else {
        return null
      }
    },
    matchedRenderActionText () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let actionSegment = matchedRenderAction.actionSegment
        if (actionSegment) {
          if (actionSegment.segments && actionSegment.segments.length) {
            return actionSegment.segments.map(segment => {
              if (segment.field) {
                return getValueByPath(this.rowData, segment.value)
              }
              return segment.value
            }).join('')
          }
        }
        return matchedRenderAction.actionName
      }
    },
    matchedRenderActionIcon: function () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction && matchedRenderAction.actionType) {
        let actionIcon
        switch (matchedRenderAction.actionType) {
          case 'ADD':
            actionIcon = 'iconfont icon-add'
            break
          case 'EDIT':
            actionIcon = 'iconfont icon-edit'
            break
          case 'DELETE':
            actionIcon = 'iconfont icon-delete'
            break
          case 'IMPORT':
            actionIcon = 'iconfont icon-import'
            break
          case 'EXPORT':
            actionIcon = 'iconfont icon-export'
            break
          case 'PRINT':
            actionIcon = 'iconfont icon-printer'
            break
          case 'MARK':
            actionIcon = 'iconfont icon-tag'
            break
          case 'VIEW':
            actionIcon = 'iconfont icon-inquire'
            break
          case 'CLOCK':
            actionIcon = 'iconfont icon-clock'
            break
          case 'GRANT':
            actionIcon = 'iconfont icon-not-pass'
            break
          case 'ACCOUNT':
            actionIcon = 'iconfont icon-account-only'
            break
          case 'TOOL':
            actionIcon = 'iconfont icon-briefcase'
            break
          default:
            actionIcon = matchedRenderAction.actionType
            break
        }
        return actionIcon
      }
    },
    matchedRenderRendered () {
      return !!this.matchedRenderActionText || !!this.matchedRenderActionIcon
    },
    cellValue: function () {
      return getValueByPath(this.rowData, this.tableColumn.prop)
    },
    // 获取请求链接
    actionPath: function () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let actionPath = matchedRenderAction['actionPath']
        if (actionPath) {
          actionPath = this.getParameterPath(actionPath)
          if (actionPath && actionPath.startsWith('/')) {
            actionPath = this.$contextPath(actionPath)
          }
          return actionPath
        }
      }
      return null
    },
    // 获取弹窗宽度
    computeDialogWidth: function () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let dimension = matchedRenderAction.dimension
        if (dimension && dimension.width) {
          return dimension.width + 'px'
        }
      }
      return null
    },
    // 获取弹窗内部样式
    computeDialogWrapStyle: function () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let dimension = matchedRenderAction.dimension
        let style = {}
        if (dimension && dimension.height) {
          style.height = dimension.height + 'px'
        }
        return style
      }
      return null
    }
  },
  methods: {
    // 获取参数化的地址
    getParameterPath (actionPath) {
      if (actionPath) {
        let id = objectUtils.toString(getValueByPath(this.rowData, 'id'))
        let param = objectUtils.toString(this.cellValue)
        actionPath = actionPath.replace(new RegExp('\\$\\{id\\}', 'gm'), id)
          .replace(new RegExp('\\$\\{param\\}', 'gm'), param)
        return actionPath
      } else {
        return null
      }
    },
    // AJAX方式
    handleAjaxClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let actionPath = matchedRenderAction['actionPath']
        if (actionPath) {
          let confirmMsg = matchedRenderAction['confirmMsg']
          if (confirmMsg) {
            this.$confirm(confirmMsg, '操作确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: matchedRenderAction['confirmType'] || 'warning'
            }).then(() => {
              this.handleAjaxRequest(actionPath)
            }).catch(() => {})
          } else {
            this.handleAjaxRequest(actionPath)
          }
        } else {
          this.$message({
            message: '请求链接信息缺失',
            type: 'warning',
            center: true
          })
        }
      } else {
        this.$message({
          message: '请求信息缺失',
          type: 'warning',
          center: true
        })
      }
    },
    // Route方式
    handleRouteClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let actionPath = matchedRenderAction['actionPath']
        if (actionPath) {
          let routeUrl = this.getParameterPath(actionPath)
          let routeTargetType = matchedRenderAction['routeTargetType']
          this.$emit('changeRoutePath', routeUrl, routeTargetType, this.rowData)
        } else {
          this.$message({
            message: '请求链接信息缺失',
            type: 'warning',
            center: true
          })
        }
      } else {
        this.$message({
          message: '请求信息缺失',
          type: 'warning',
          center: true
        })
      }
    },
    // 拷贝操作
    handleCopyClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        let actionPath = matchedRenderAction['actionPath']
        if (actionPath) {
          let copyObj = this.getParameterPath(actionPath)
          this.$copyText(copyObj).then(() => {
            this.$notify({
              title: '复制成功',
              message: '内容成功复制到剪贴板',
              type: 'success'
            })
          }, () => {
            this.$message.error({
              message: '浏览器不支持复制',
              center: true
            })
          })
        } else {
          this.$message({
            message: '拷贝数据信息缺失',
            type: 'warning',
            center: true
          })
        }
      } else {
        this.$message({
          message: '拷贝信息缺失',
          type: 'warning',
          center: true
        })
      }
    },
    // 编辑操作
    handleUpdateClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        this.$emit('updateGridRow', this.rowData)
      } else {
        this.$message({
          message: '编辑信息缺失',
          type: 'warning',
          center: true
        })
      }
    },
    // 重新加载数据
    reloadGridData () {
      this.$emit('reloadGridData')
    },
    // 弹出组件操作
    handlePopupClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.popupInstance) {
          this.popover.popupInstance.visible = true
        } else {
          this.popover.popupInstance = popover.$dialog({
            parent: this.$grid,
            dialogAttrs: this.$extend({
              decorator: matchedRenderAction.decorator,
              title: matchedRenderAction.actionName || this.matchedRenderActionText,
              width: this.computeDialogWidth,
              center: true
            }, matchedRenderAction.extraAttrs),
            wrapAttrs: {
              style: this.computeDialogWrapStyle
            },
            listeners: {
              reloadGridData: this.reloadGridData,
              hidePopover: this.hidePopup,
              hidePopoverAndRefresh: this.hidePopupAndRefresh,
              hidePopup: this.hidePopup,
              hidePopupAndRefresh: this.hidePopupAndRefresh
            },
            attrs: this.$extend({
              'component-path': matchedRenderAction.actionPath,
              'table-column': this.tableColumn,
              'row-index': this.rowIndex,
              'row-data': this.rowData,
              'cell-value': this.cellValue,
              'extra-key': this.matchedRenderAction.extraKey,
              'extra-id': this.cellValue,
              'extra-value': this.cellValue,
              'extra-params': matchedRenderAction.extraParams
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭弹出窗口
    hidePopup () {
      if (this.popover.popupInstance) {
        this.popover.popupInstance.visible = false
      }
    },
    // 关闭并且刷新
    hidePopupAndRefresh () {
      if (this.popover.popupInstance) {
        this.popover.popupInstance.visible = false
      }
      if (this.$grid) {
        this.$grid.loadGridData()
      }
    },
    // 弹出抽屉操作
    handleDrawerClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.drawerInstance) {
          this.popover.drawerInstance.visible = true
        } else {
          this.popover.drawerInstance = popover.$drawer({
            parent: this.$grid,
            drawerAttrs: this.$extend({
              class: matchedRenderAction.dimension ? 'dimension--' + matchedRenderAction.dimension.type : '',
              decorator: matchedRenderAction.decorator
            }, matchedRenderAction.extraAttrs),
            listeners: {
              reloadGridData: this.reloadGridData,
              hidePopover: this.hideDrawer,
              hidePopoverAndRefresh: this.hideDrawerAndRefresh,
              hideDrawer: this.hideDrawer,
              hideDrawerAndRefresh: this.hideDrawerAndRefresh
            },
            attrs: this.$extend({
              'component-path': matchedRenderAction.actionPath,
              'table-column': this.tableColumn,
              'row-index': this.rowIndex,
              'row-data': this.rowData,
              'cell-value': this.cellValue,
              'extra-key': this.matchedRenderAction.extraKey,
              'extra-id': this.cellValue,
              'extra-value': this.cellValue,
              'extra-params': matchedRenderAction.extraParams
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭抽屉
    hideDrawer () {
      if (this.popover.drawerInstance) {
        this.popover.drawerInstance.visible = false
      }
    },
    // 关闭并且刷新
    hideDrawerAndRefresh () {
      if (this.popover.drawerInstance) {
        this.popover.drawerInstance.visible = false
      }
      if (this.$grid) {
        this.$grid.loadGridData()
      }
    },
    // 打开关闭气泡
    handleBubbleClick () {
      this.popover.isShowBubble = !this.popover.isShowBubble
    },
    // 关闭气泡
    hideBubble () {
      this.popover.isShowBubble = false
    },
    // 关闭并且刷新
    hideBubbleAndRefresh () {
      this.popover.isShowBubble = false
      this.reloadGridData()
    },
    // 打开关闭层级页面
    handleCascadeClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.cascadeInstance) {
          this.popover.cascadeInstance.visible = true
        } else {
          this.popover.cascadeInstance = popover.$cascade({
            parent: this.$grid,
            cascadeAttrs: this.$extend({
              decorator: matchedRenderAction.decorator,
              content: matchedRenderAction.actionName || this.matchedRenderActionText
            }, matchedRenderAction.extraAttrs),
            listeners: {
              reloadGridData: this.reloadGridData,
              hidePopover: this.hideCascade,
              hidePopoverAndRefresh: this.hideCascadeAndRefresh,
              hideCascade: this.hideCascade,
              hideCascadeAndRefresh: this.hideCascadeAndRefresh
            },
            attrs: this.$extend({
              'component-path': matchedRenderAction.actionPath,
              'table-column': this.tableColumn,
              'row-index': this.rowIndex,
              'row-data': this.rowData,
              'cell-value': this.cellValue,
              'extra-key': this.matchedRenderAction.extraKey,
              'extra-id': this.cellValue,
              'extra-value': this.cellValue,
              'extra-params': matchedRenderAction.extraParams
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭层级页面
    hideCascade () {
      if (this.popover.cascadeInstance) {
        this.popover.cascadeInstance.visible = false
      }
    },
    // 关闭并且刷新
    hideCascadeAndRefresh () {
      if (this.popover.cascadeInstance) {
        this.popover.cascadeInstance.visible = false
      }
      if (this.$grid) {
        this.$grid.loadGridData()
      }
    },
    // 打开导入数据窗口
    handleImportClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.importInstance) {
          this.popover.importInstance.visible = true
        } else {
          this.popover.importInstance = popover.$import({
            parent: this.$grid,
            dialogAttrs: this.$extend({
              decorator: matchedRenderAction.decorator,
              title: matchedRenderAction.actionName || this.matchedRenderActionText,
              width: this.computeDialogWidth,
              center: true
            }, matchedRenderAction.extraAttrs),
            listeners: {
              hideImport: this.hideImport,
              dataImportSuccess: this.reloadGridData
            },
            attrs: this.$extend({
              'import-url': matchedRenderAction.actionPath,
              'extra-params': this.$extend({
                postId: this.rowData.id
              }, matchedRenderAction.extraParams)
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭导入数据窗口
    hideImport () {
      if (this.popover.importInstance) {
        this.popover.importInstance.visible = false
      }
    },
    // 打开解包数据窗口
    handleUnpackClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.unpackInstance) {
          this.popover.unpackInstance.visible = true
        } else {
          this.popover.unpackInstance = popover.$unpack({
            parent: this.$grid,
            dialogAttrs: this.$extend({
              decorator: matchedRenderAction.decorator,
              title: matchedRenderAction.actionName || this.matchedRenderActionText,
              width: this.computeDialogWidth,
              center: true
            }, matchedRenderAction.extraAttrs),
            listeners: {
              hideUnpack: this.hideUnpack,
              dataUnpackSuccess: this.reloadGridData
            },
            attrs: this.$extend({
              'unpack-url': matchedRenderAction.actionPath,
              'extra-params': this.$extend({
                postId: this.rowData.id
              }, matchedRenderAction.extraParams)
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭导入数据窗口
    hideUnpack () {
      if (this.popover.unpackInstance) {
        this.popover.unpackInstance.visible = false
      }
    },
    // 打开异步任务窗口
    handleAsyncClick () {
      let matchedRenderAction = this.matchedRenderAction
      if (matchedRenderAction) {
        if (this.popover.asyncInstance) {
          this.popover.asyncInstance.visible = true
        } else {
          this.popover.asyncInstance = popover.$async({
            parent: this.$grid,
            dialogAttrs: this.$extend({
              decorator: matchedRenderAction.decorator,
              title: matchedRenderAction.actionName || this.matchedRenderActionText,
              width: this.computeDialogWidth,
              center: true
            }, matchedRenderAction.extraAttrs),
            listeners: {
              onComplete: this.reloadGridData
            },
            attrs: this.$extend({
              'action-url': matchedRenderAction.actionPath,
              'confirm-msg': matchedRenderAction.confirmMsg,
              'extra-params': this.$extend({
                postId: this.rowData.id
              }, matchedRenderAction.extraParams)
            }, this.$attrs)
          })
        }
      }
    },
    // 关闭异步任务窗口
    hideAsync () {
      if (this.popover.asyncInstance) {
        this.popover.asyncInstance.visible = false
      }
    },
    // AJAX请求
    handleAjaxRequest (url) {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      let loadingInstance = Loading.service({
        target: this.$grid.$el,
        text: '请求提交中，请稍候...'
      })
      let params = this.$extend({
        postId: objectUtils.toString(getValueByPath(this.rowData, 'id')),
        postData: objectUtils.toString(this.cellValue)
      }, postParams)
      this.$ajax({
        url: url,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message({
                message: response.data['message'],
                type: 'success',
                center: true
              })
              this.$bus.$emit(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`)
              this.reloadGridData()
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍候重试',
          center: true
        })
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
      })
    },
    getBehaviorType (tableColumn) {
      let getTableColumn = tableColumn || this.tableColumn
      if (getTableColumn) {
        let renderAction = getTableColumn['renderAction']
        if (renderAction) {
          return renderAction.behaviorType
        }
      }
      return null
    },
    // 行为触发（部分类型不支持）
    handleBehaviorClick (behavior) {
      if (!this.is__hidden && this.tableColumn === behavior) {
        let matchedRenderAction = this.matchedRenderAction
        if (matchedRenderAction) {
          switch (matchedRenderAction.handlerType) {
            case 'AJAX': {
              this.handleAjaxClick()
              break
            }
            case 'ROUTE': {
              this.handleRouteClick()
              break
            }
            case 'COPY': {
              this.handleCopyClick()
              break
            }
            case 'UPDATE': {
              this.handleUpdateClick()
              break
            }
            case 'POPUP': {
              this.handlePopupClick()
              break
            }
            case 'DRAWER': {
              this.handleDrawerClick()
              break
            }
            case 'CASCADE': {
              this.handleCascadeClick()
              break
            }
          }
        }
      }
    },
    installEvent (tableColumn) {
      let behaviorType = this.getBehaviorType(tableColumn)
      if (behaviorType) {
        switch (behaviorType) {
          case 'ROW_CLICK': {
            this.$bus.$on(`${globalEvent.templateGrid.ROW_CLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(this.rowData, 'id')}`, this.handleBehaviorClick)
            break
          }
          case 'ROW_DBLCLICK': {
            this.$bus.$on(`${globalEvent.templateGrid.ROW_DBLCLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(this.rowData, 'id')}`, this.handleBehaviorClick)
            break
          }
        }
      }
    },
    uninstallEvent (tableColumn) {
      let behaviorType = this.getBehaviorType(tableColumn)
      if (behaviorType) {
        switch (behaviorType) {
          case 'ROW_CLICK': {
            this.$bus.$off(`${globalEvent.templateGrid.ROW_CLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(this.rowData, 'id')}`, this.handleBehaviorClick)
            break
          }
          case 'ROW_DBLCLICK': {
            this.$bus.$off(`${globalEvent.templateGrid.ROW_DBLCLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(this.rowData, 'id')}`, this.handleBehaviorClick)
            break
          }
        }
      }
    },
    onRenderActionChanged () {
      if (this.popover.popupInstance) {
        this.popover.popupInstance.$destroy()
        this.popover.popupInstance = null
      }
      if (this.popover.drawerInstance) {
        this.popover.drawerInstance.$destroy()
        this.popover.drawerInstance = null
      }
      if (this.popover.cascadeInstance) {
        this.popover.cascadeInstance.$destroy()
        this.popover.cascadeInstance = null
      }
      if (this.popover.importInstance) {
        this.popover.importInstance.$destroy()
        this.popover.importInstance = null
      }
      if (this.popover.unpackInstance) {
        this.popover.unpackInstance.$destroy()
        this.popover.unpackInstance = null
      }
      if (this.popover.asyncInstance) {
        this.popover.asyncInstance.$destroy()
        this.popover.asyncInstance = null
      }
    }
  },
  mounted () {
    this.installEvent()
  },
  beforeDestroy () {
    this.uninstallEvent()
    if (this.popover.popupInstance && !this.popover.popupInstance.visible) {
      this.popover.popupInstance.$destroy()
    }
    if (this.popover.drawerInstance && !this.popover.drawerInstance.visible) {
      this.popover.drawerInstance.$destroy()
    }
    if (this.popover.cascadeInstance && !this.popover.cascadeInstance.visible) {
      this.popover.cascadeInstance.$destroy()
    }
    if (this.popover.importInstance && !this.popover.importInstance.visible) {
      this.popover.importInstance.$destroy()
    }
    if (this.popover.unpackInstance && !this.popover.unpackInstance.visible) {
      this.popover.unpackInstance.$destroy()
    }
    if (this.popover.asyncInstance && !this.popover.asyncInstance.visible) {
      this.popover.asyncInstance.$destroy()
    }
  },
  watch: {
    tableColumn: function (newVal, oldVal) {
      if (oldVal) {
        this.uninstallEvent(oldVal)
      }
      if (newVal) {
        this.installEvent(newVal)
      }
    },
    'matchedRenderAction.actionName': function () {
      this.onRenderActionChanged()
    },
    'matchedRenderAction.actionPath': function () {
      this.onRenderActionChanged()
    }
  },
  deactivated () {
    if (this.popover.popupInstance) {
      this.popover.popupInstance.visible = false
    }
    if (this.popover.drawerInstance) {
      this.popover.drawerInstance.visible = false
    }
    if (this.popover.importInstance) {
      this.popover.importInstance.visible = false
    }
    if (this.popover.unpackInstance) {
      this.popover.unpackInstance.visible = false
    }
    if (this.popover.asyncInstance) {
      this.popover.asyncInstance.visible = false
    }
    this.popover.isShowBubble = false
  }
}
</script>
